import { Checkbox, DataSource, ExcludableTextbox, Label, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutInvoicesDueReminderReport extends Layout {
    checkboxEmailStatement: Checkbox;
    checkboxPayableContact: Checkbox;
    excludabletextboxCat: ExcludableTextbox;
    excludabletextboxCustomer: ExcludableTextbox;
    labelDays: Label;
    labelDueTo: Label;
    sourceInvoicesDueReminder: DataSource;
    switchReminderType: Switch;
    switchSortBy: Switch;
    textboxAgeDate: Textbox;
    textboxCutoffDate: Textbox;
    textboxDueInDays: Textbox;
    textboxDueInToDays: Textbox;
    textboxEditSubject: Textbox;
    textboxEmailFormat: Textbox;
    textboxEmailProfileId: Textbox;
    textboxRecipient: Textbox;
    textboxReportFormat: Textbox;
}
